import { Box } from "@mui/material";
import React from "react";

interface OverlayWrapperProps {
  children: React.ReactNode;
  width?: string;
}

/**
 * Reusable wrapper component for overlay-style displays
 * Provides consistent positioning, sizing, and styling for overlays
 * that slide in from the right side of the screen
 */
const OverlayWrapper: React.FC<OverlayWrapperProps> = ({
  children,
  width = "45%",
}) => {
  return (
    <Box
      data-overlay-content
      sx={{
        position: "fixed",
        top: 0,
        right: 0,
        width: width,
        height: "100%",
        backgroundColor: "background.paper",
        borderLeft: 1,
        borderColor: "divider",
        // Lifts the panel off the page it lies over
        boxShadow: "-16px 0 40px rgba(0, 0, 0, 0.45)",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </Box>
  );
};

export default OverlayWrapper;
